<app-header></app-header>
<app-navigation-bar (onBurgerClicked)="toggleDrawer()"></app-navigation-bar>
<app-drawer [open]="drawerIsOpen" (onClose)="drawerIsOpen=false"></app-drawer>

<div class="page-content" *ngIf="referralData">

    <div class="back-container">
        <a [routerLink]="'/' + getCountry() + '/referrals'" class="back-btn">< {{getString('back')}}</a>
    </div>

    <div class="section s1">
        <h1 class="s1-title">{{getString('redeemPageTitle')}}</h1>
        <div class="s1-text bigger-text">{{getString('redeemPageText')}}</div>
    </div>
    <div class="section s2">
        <div class="points-card">
            <img class="piggie" src="./assets/images/pig_blue.png">
            <div class="big-text">{{getString('yourPoints')}}</div>
            <div class="points">{{referralData.user.points}}</div>
        </div>
    </div>
    <div class="section s3">
        <div class="bold label">{{getString('availableiTunesGiftCards')}}</div>
        <div class="dropdown">
            <div class="dd-selected" (click)="countryClicked()">
                <img alt="" class="country-logo" [src]="selectedCountry.icon">
                <span class="country-name">{{getString(selectedCountry.string)}}</span>
                <img src="./assets/images/right_arrow.png" class="dd-arrow">
            </div>
            <div #countryDDContent class="dropdown-content">
        
                <div class="dd-item" *ngFor="let country of countries" (click)="selectCountry(country)">
                    <img alt="" class="country-logo" [src]="country.icon">
                    <span class="country-name">{{getString(country.string)}}</span>
                </div>
        
            </div>
        </div>

        <div *ngIf="noProductsAvailable" class="no-products">
            {{getString('noProductsAvailable')}}
            <div>
                <a [href]="'/' + getCountry() + '/' + getString('contactUrl')" class="blue-text">{{getString('buyCardsForOtherLandContact')}}</a>
            </div>
        </div>

        <ng-container *ngFor="let product of products">

            <div *ngIf="product.productType == 'ITUNES_GIFT_CARD'" class="card">

                <div class="third">
                    <img src="./assets/images/itunes_multiple.png" class="card-img">
                    <img [src]="getFlagSrc(product)" class="card-flag">
                    <span class="card-value">
                        <span class="card-currency">{{getCardCurrency(product)}}</span>
                        <span class="card-price">{{getCardPrice(product)}}</span>
                    </span>
                    <div class="gray-text card-subtext">{{getCardSubText(product)}}</div>
                </div>
                <div class="third">
                    <div *ngIf="product.costsInPointsBefore > product.costsInPoints" class="cost">
                        <div class="points green-text">{{product.costsInPoints}} <span class="big-text">{{getString('points')}}</span></div>
                        <span class="gray-text before">
                            <span class="strike">{{product.costsInPointsBefore}}</span>
                            <span> {{getString('points')}}</span>
                        </span>
                    </div>
                    <div *ngIf="product.costsInPointsBefore <= product.costsInPoints" class="cost">
                        <span class="points">{{product.costsInPoints}}</span>
                        <span class="big-text"> {{getString('points')}}</span>
                    </div>
                </div>
                <div class="third">
                    <button class="blue-button" (click)="order(product)">{{getString('orderGiftCard')}}</button>
                </div>
                
            </div>
            
        </ng-container>
    </div>

    <div class="section s4" *ngIf="transactions && transactions.length > 0">
        <div class="bold label">{{getString('yourTransactionHistory')}}</div>
        <table class="desktop">
            <thead>
               <tr>
                    <th>{{getString('orderDate')}}</th>
                    <th>{{getString('cardType')}}</th>
                    <th>{{getString('pointsUsed')}}</th>
                    <th>{{getString('status')}}</th>
                    <th>{{getString('action')}}</th>
               </tr> 
            </thead>
            <tbody>
                <tr *ngFor="let transaction of transactions">
                    <td>{{getFormattedDate(transaction.dateCreated)}}</td>
                    <td>{{getDisplayProductType(transaction.product)}}</td>
                    <td>-{{transaction.points}}</td>
                    <td *ngIf="transaction.transactionStatus == 'WAITING_FOR_APPROVAL'">{{getString("waitingForApproval")}}</td>
                    <td *ngIf="transaction.transactionStatus == 'APPROVED_AND_CODE_SENT'" class="green-text">{{getString("approved")}}</td>
                    <td>
                        <span *ngIf="transaction.transactionStatus == 'WAITING_FOR_APPROVAL'" class="action gray-text">{{getString('resendCode')}}</span>
                        <span *ngIf="transaction.transactionStatus == 'APPROVED_AND_CODE_SENT'" class="action blue-text" (click)="resendCode(transaction)">{{getString('resendCode')}}</span>
                    </td>
                </tr>
            </tbody>
        </table>
        <table class="card mobile" *ngFor="let transaction of transactions">
            <tr>
                <th>{{getString('orderDate')}}</th>
                <td>{{getFormattedDate(transaction.dateCreated)}}</td>
            </tr>
            <tr>
                <th>{{getString('cardType')}}</th>
                <td>{{getDisplayProductType(transaction.product)}}</td>
            </tr>
            <tr>
                <th>{{getString('pointsUsed')}}</th>
                <td>-{{transaction.points}}</td>
            </tr>
            <tr>
                <th>{{getString('status')}}</th>
                <td *ngIf="transaction.transactionStatus == 'WAITING_FOR_APPROVAL'">{{getString("waitingForApproval")}}</td>
                <td *ngIf="transaction.transactionStatus == 'APPROVED'" class="green-text">{{getString("approved")}}</td>
            </tr>
            <tr>
                <th>{{getString('action')}}</th>
                <td>
                    <span *ngIf="transaction.transactionStatus == 'WAITING_FOR_APPROVAL'" class="gray-text action">{{getString('resendCode')}}</span>
                        <span *ngIf="transaction.transactionStatus == 'APPROVED'" class="blue-text action" (click)="resendCode(transaction)">{{getString('resendCode')}}</span>
                </td>
            </tr>
        </table>
    </div>


</div>
<div>
    <app-home-footer></app-home-footer>
</div>